import { XSquareFill } from 'react-bootstrap-icons';
import styled from 'styled-components';
import Card from '@designSystem/Card';
import theme from '@theme';

export const StyledAddressCard = styled(Card)<{ color: string }>`
  --color: ${(props) => props.color};
  > div {
    padding: 8px 12px;
  }
  margin-right: 20px;
  &.select {
    background-color: rgba(var(--color), 0.3);
    border: 2px solid rgba(var(--color));
    color: rgba(var(--color));
  }
  :not(.select) {
    background-color: rgba(var(--color), 0.2);
    border: 1px solid rgba(var(--color));
  }
`;

export const UndefinedPlot = styled(XSquareFill)<{ $disable?: boolean }>`
  position: absolute;
  width: 10px;
  height: 10px;
  top: -5px;
  left: -5px;
  cursor: ${(props) => (props.$disable ? 'auto' : 'pointer')};
  box-shadow: 0 2px 5px 0 grey;
`;

export const UndefinedPlotHover = styled(UndefinedPlot)`
  width: 20px;
  height: 20px;
`;

export const Plot = styled.div<{ $color: string; $disable?: boolean }>`
  --color: ${(props) => props.$color};
  position: absolute;
  width: 10px;
  height: 10px;
  top: -5px;
  left: -5px;
  border: 1px solid #025a73;
  border-radius: 10px;
  border-color: white;
  background-color: rgba(var(--color));
  cursor: ${(props) => (props.$disable ? 'auto' : 'pointer')};
  box-shadow: 0 2px 5px 0 grey;
`;

export const PlotHover = styled(Plot)`
  width: 20px;
  height: 20px;
`;

export const StyledPopUpTitle = styled.span`
  font-weight: ${theme.fonts.weight.regular};
  font-size: ${theme.fonts.size.xxs};
  line-height: ${theme.fonts.spacing.xxs};
  word-break: break-all;

  color: ${theme.palette.grey[400]};
`;

export const StyledPopUpContent = styled.span`
  display: flex;
  font-weight: ${theme.fonts.weight.medium};
  font-size: ${theme.fonts.size.sm};
  line-height: ${theme.fonts.spacing.sm};
  color: ${theme.palette.grey[500]};
`;

export const PlotPopUp = styled.div<{ showPopUp: boolean }>`
  visibility: ${(props) => (props.showPopUp ? 'visible' : 'hidden')};
`;

export const ClosingCross = styled.span`
  position: absolute;
  right: 10px;
  clickable: true;
  cursor: pointer;
`;

export const StyledAddressListCards = styled.div`
  display: grid;
  grid-row-gap: 12px;
  margin-top: 0.5rem;
  height: calc(100vh - 400px);
  grid-auto-rows: max-content;
  grid-template-columns: repeat(2, 1fr);
`;

export const StyledAddressListCard = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const StyledIPEAddressesCards = styled.div`
  grid-column: 1;
`;

export const StyledBANAddressesCards = styled.div`
  grid-column: 2;
`;

export const SelectMismatchCustomWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
`;

export const SelectMismatchCustomCard = styled(Card)`
  max-width: 50%;
`;

export const SelectMismatchCustomMap = styled.div`
  height: 100%;
  width: 100%;
  max-width: 50%;
  position: relative;
  height: calc(100vh - 150px);

  button {
    z-index: 3;
    position: absolute;
    top: 0;
  }
`;

export const SelectMismatchMapWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: sticky;
  top: 80px;

  @media screen and (max-width: 40em) {
    display: none;
  }
`;

export const StyledSelectMismatchFooter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledSelectMismatchCardBodyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid ${theme.palette.grey[200]};
`;

export const SelectMismatchLegendPlot = styled.div<{ color: string }>`
  margin-right: 5px;
  width: 10px;
  height: 10px;
  top: -5px;
  left: -5px;
  border: 1px solid;
  border-radius: 10px;
  border-color: white;
  background-color: ${(props) => props.color};
  box-shadow: 0 2px 5px 0 grey;
`;

export const SelectMismatchLegendElement = styled.div`
  display: flex;
  font-weight: ${theme.fonts.weight.regular};
  font-size: ${theme.fonts.size.xxs};
  line-height: ${theme.fonts.spacing.xxs};
  word-break: break-all;
  color: ${theme.palette.grey[500]};
`;

export const SelectMismatchLegend = styled.div`
  column-count: 2;
  grid-column: 1 / 3;
`;
